import { cn } from '@plato/ui/util/classes';
import { forwardRef } from 'react';

export const Page = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
    ({ children, className, ...props }, ref) => {
        return (
            <div
                className={cn(
                    'flex grow flex-col gap-3 overflow-y-auto px-5 pb-4 max-sm:pb-20 sm:px-4',
                    className,
                )}
                ref={ref}
                {...props}
            >
                {children}
            </div>
        );
    },
);

Page.displayName = 'Page';
